/** 热卖商品 **/
<template>
  <div class="leftaside">
    <h4>{{navTitle}}</h4>
    <ul class="left_product">
      <li v-for="(item,index) in hotGoodsList.slice(0,10)" :key="index">
        <div class="p-img">
          <router-link :to="`/goodsdetail?id=${item.id}`" target="_blank" class="item_link">
            <!-- <el-image class="img-responsive" :src="`${item.photos}`" style="display: block">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image> -->
            <img v-lazy="item.photos" alt="" class="img-responsive">
          </router-link>
          <div class="pro_name" @click="looksku(item)">
            <p class="goodsName">
              {{ item.name }}
            </p>
            <div class="salemsg">
              <p class="salePrice">
                <i>¥</i>
                <!-- // member_price  非0   member_price
                  // 等于0     marketprice  
                 // 等于null   marketprice  
                 // 等于""    marketprice  
                 // 等于-1    面议    -->
                <!-- <span class="priceText">{{(item.member_price!=null && item.member_price!="") ? item.member_price!=-1 ? item.member_price : '面议' :
                  item.marketprice}}
                </span> -->
                <span class="priceText">
                  <!-- {{userInfo.userId?item.member_price:item.real_price}} -->
                  {{item.newPrice||'面议'}}
                </span>
              </p>
              <p class="saleNum">{{ item.saleNum ? `已售${item.saleNum}件` : "" }}</p>
            </div>
          </div>
          <!-- 商城 -->
          <!-- <router-link
            v-if="supplieStore==0?true:false"
            class="item_link"
            :to="`/goodsdetail?id=${item.id}`"
            @click.native="$router.go(0)"
          >
            <el-image class="img-responsive" :src="`${item.photos}`" style="display: block" >
                 <div slot="error" class="image-slot">
                   <i class="el-icon-picture-outline"></i>
                 </div>
            </el-image>
          </router-link> -->
          <!-- 批发市场 -->
          <!-- <router-link
          v-if="supplieStore"
            class="item_link"
            :to="`/goodsDetail_supplie?id=${item.id}`"
            @click.native="$router.go(0)"
          >
            <el-image class="img-responsive" :src="`${item.photos}`" style="display: block" >
                 <div slot="error" class="image-slot">
                   <i class="el-icon-picture-outline"></i>
                 </div>
            </el-image>
          </router-link> -->
          <!-- </div> -->
          <!-- <div class="pro-price"> -->
          <!-- <strong><em>¥</em><i>{{(item.price!=null && item.price!="")?item.price: item.marketprice}}</i></strong> -->
          <!-- <strong><em>¥</em><i>{{item.member_price}}</i></strong> -->
          <!-- </div> -->
          <!-- <div class="pro_name"> -->
          <!-- 商城 -->
          <!-- <router-link v-if="supplieStore==0?true:false" :to="`/goodsdetail?id=${item.id}`" @click.native="$router.go(0)">{{item.name}}</router-link> -->
          <!-- 批发市场 -->
          <!-- <router-link v-if="supplieStore" :to="`/goodsDetail_supplie?id=${item.id}`" @click.native="$router.go(0)">{{item.name}}</router-link> -->
        </div>
      </li>
      <li>
        <div class="nodate" v-if="hotGoodsList.length==0?true:false">
          <div class="first">暂无热销商品</div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      };
    },
    props: ['navTitle', 'hotGoodsList', 'supplieStore'],
    // 注册组件
    components: {},
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() { },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      looksku(item) {
        let route = this.$router.resolve({
          path: '/goodsdetail',
          query: {
            id: item.id
          }
        });
        window.open(route.href, '_blank');
      }
    },
  };
</script>

<style scoped lang="less">
  .pro_name {
    font-size: 14px;
    .goodsName {
      padding: 4px 0;
      height: 38px;
      line-height: 20px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .salemsg {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .salePrice {
        color: #EA0A2A;
        .priceText {
          font-size: 16px;
        }
      }
      .saleNum {
        color: #888;
        font-size: 12px;
        letter-spacing: 1px;
      }
    }
  }

  .leftaside {
    box-sizing: border-box;
    font-size: 14px;
    border: 1px solid #ddd;
    margin-right: 10px;
  }

  .leftaside h4 {
    padding: 10px;
    border-bottom: 1px solid #ddd;
    font-weight: 600;
  }

  .left_product {
    padding: 10px;
  }

  .left_product li {
    margin-bottom: 20px;
  }

  .pro-price {
    margin: 10px 0;
    color: #e4393c;
  }


  .img-responsive {
    /* width: 100%; */
    width: 160px;
    height: 160px;
    object-fit:cover;
  }

  .nodate {
    text-align: center;
    margin-top: 20%;
    font-size: 14px;
  }

  .nodate .first {
    margin: 40upx 0 12upx;
    font-size: 28upx;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotGoods.vue